// Shared shell for agent pages — title, tab strip, content area.
import React from 'react';
import { Box, Typography, Tabs, Tab, Paper, Alert } from '@mui/material';

export default function AgentPageShell({ title, subtitle, tabs, activeTab, onTabChange, children, error }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box>
                <Typography variant="h4" sx={{ fontWeight: 600, mb: 0 }}>{title}</Typography>
                {subtitle && (
                    <Typography variant="caption" color="text.secondary">{subtitle}</Typography>
                )}
            </Box>
            {error && <Alert severity="error" sx={{ py: 0 }}>{error}</Alert>}
            <Paper sx={{ p: 0 }}>
                <Tabs
                    value={activeTab}
                    onChange={(_, v) => onTabChange(v)}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {tabs.map((t, i) => <Tab key={i} label={t} />)}
                </Tabs>
                <Box sx={{ p: 1 }}>{children}</Box>
            </Paper>
        </Box>
    );
}
